export const SET_RESUME_DATA = "SET_RESUME_DATA";

export const setResumeData = (data) => ({ type: SET_RESUME_DATA, data });



// WEBPACK FOOTER //
// ./src/actions/resume.js